/**
 * Portal public API
 *
 * Usage:
 *      - Playtech.on(Playtech.Events.LOGGED_IN, function() { // User is logged in })
 *
 *      - var userData = Playtech.fetchUserDetails(); //  {role: "user", lang: "en_CA", languageDetected: true, userName: "test-21"...}
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var user = require('user');
    var Playtech = window.Playtech || {};

    var api = _.extend(Playtech, {
        /**
         * Returns user details that were fetched once when player has logged in.
         * For just-in-time request for details please see [getPlayerData API]{@link Playtech.API.user.getPlayerData}.
         * @memberOf Playtech
         * @function
         * @returns {Object}
         * @example
         * // {birthDate: "1989-04-03", casinoName: "playtech800075", email: "test@playech.com", ...}
         * Playtech.fetchUserDetails();
         * @example
         * // { previousLoginTime: undefined, sessionId: undefined }
         * Playtech.fetchUserDetails();
         */
        fetchUserDetails: function() {
            return _.extend(_.omit(user.get('userDetails'), 'password'), {
                sessionId: user.get('windowSessionId'),
                previousLoginTime: user.get('previousLoginTime')
            });
        },

        /**
         * Returns user balance
         * @memberOf Playtech
         * @function
         * @returns {Object} {formattedBalance: string, totalAmount: string, balances: {[balance_type]: amount: string, currencyCode: string}} Value of balance_type: 'withdrawable_balance', 'free_spin_balance', 'casino_bonus_buyin_balance', 'ringfenced_real_balance', 'bonus_balance', 'casino_gaming_balance', 'real_gaming_balance', 'total_bonus_balance', 'bonus_pending_winnings', 'pending_withdrawals'.
         * @example
         * // {balances: {…}, totalAmount: '0', formattedBalance: '£ 0.00'}
         * Playtech.getUserBalance();
         */
        getUserBalance: function() {
            return user.get('balance');
        },
    });

    module.exports = api;
});
